import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5 2.08325V7.91659",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.08337 5H7.91671",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPlus;
